import { Avatar } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import logo from "../../../../assets/logo.png";
import { useLanguageTheme } from "../../../../hooks/useLanguageTheme";
import { useUserProfile } from "../../../../hooks/useUserProfile";
import { useNavigate } from "react-router-dom";
import { profileSidebarItems } from "../../constants";
import { SidebarButton } from "../SidebarButton";

export const ProfileDesktopSideBar = ({
  activeTab,
  handleTabChange,
  setSidebarWidth,
}: {
  activeTab: string;
  handleTabChange: any;
  setSidebarWidth: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { i18n, t } = useTranslation(["profile"]);
  const langTheme = useLanguageTheme();
  const navigate = useNavigate();

  const { profile }: { profile: any } = useUserProfile();

  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) {
        setSidebarWidth(343);
      } else if (window.innerWidth > 1000) {
        setSidebarWidth(290);
      } else {
        setSidebarWidth(210);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleItemClick = (item: string) => {
    if (item === "logout") {
      localStorage.removeItem("jwt");
      localStorage.removeItem("user");
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("user");

      if (window.location.pathname === "/home") {
        window.location.reload();
      } else {
        navigate("/home");
      }
    } else {
      handleTabChange(item);
    }
  };

  return (
    <aside
      ref={sidebarRef}
      className="profile-desktop-sidebar-wrapper"
      style={{
        direction: i18n.dir(),
        fontFamily: langTheme.mainFont(),
      }}
    >
      <img
        src={logo}
        style={{ width: "107px", cursor: "pointer" }}
        onClick={() => navigate("/home")}
      />

      <div className="profile-desktop-sidebar-main-user-info-wrapper">
        <div className="profile-sidebar-account-text">{t("account")}</div>
        <div className="profile-desktop-sidebar-main-user-info-container">
          <Avatar
            src={profile?.profilePhoto?.src ? profile?.profilePhoto?.src : ""}
            sx={{
              bgcolor: "rgba(229, 237, 255, 1)",
              color: "rgba(43, 54, 116, 0.34)",
              width: "58px",
              height: "58px",
              fontSize: "28px",
              lineHeight: "28px",
            }}
          >
            {profile?.fullName[0]}
          </Avatar>
          <div>
            <div className="profile-desktop-sidebar-main-user-fullName">
              {profile?.fullName}
            </div>
            <div className="profile-desktop-sidebar-main-user-role">
              {t(profile?.userType)}
            </div>
          </div>
        </div>
      </div>

      <div>
        {profileSidebarItems.map((item) => (
          <SidebarButton
            key={item.value}
            icon={item.icon}
            label={t(item.label)}
            active={activeTab === item.value}
            onClick={() => handleItemClick(item.value)}
          />
        ))}
      </div>
    </aside>
  );
};
